// const weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
const weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
export const formatDate = (dateStr) => new Date(dateStr).toLocaleDateString('ro-RO')
export const formatTime = (dateStr) => new Date(dateStr).toLocaleTimeString('ro-RO')
export const dayOfDate = (dateStr) => new Date(dateStr).getDay();
export const dayNameOfDate = (dateStr) => weekday[new Date(dateStr).getDay()]
